import React from 'react';
import { SchematicShell, Rect, Line, Circle } from './SchematicPrimitives';

const IN = 0.0254;

const SLOT_W = 0.12 * IN;
const SLOT_H = 0.4 * IN;
const SLOT_GAP = 0.45 * IN;
const GROUND_R = 0.12 * IN;
const USB_W = 0.3 * IN;
const USB_H = 0.18 * IN;
const CORD_LEN = 1.5 * IN;
const CORD_R = 0.1 * IN;

function OutletSymbol({ cx, cy, strokeColor, strokeWidth }) {
  return (
    <g>
      <Rect
        x={cx - SLOT_GAP / 2 - SLOT_W / 2}
        y={cy - SLOT_H / 2}
        width={SLOT_W}
        height={SLOT_H}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Rect
        x={cx + SLOT_GAP / 2 - SLOT_W / 2}
        y={cy - SLOT_H / 2}
        width={SLOT_W}
        height={SLOT_H}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Circle
        cx={cx}
        cy={cy + SLOT_H * 0.7}
        r={GROUND_R}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </g>
  );
}

export function DormSurgeProtectorSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    const outletCY = height * 0.45;
    const cordY = height * 0.5;

    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        {[0.31, 0.69].map((frac, i) => (
          <OutletSymbol
            key={`side-outlet-${i}`}
            cx={depth * frac}
            cy={outletCY}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        ))}
        <Line
          x1={0}
          y1={cordY}
          x2={-CORD_LEN}
          y2={cordY}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
        <Line
          x1={0}
          y1={cordY - CORD_R}
          x2={-CORD_LEN}
          y2={cordY - CORD_R}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
        <Line
          x1={0}
          y1={cordY + CORD_R}
          x2={-CORD_LEN}
          y2={cordY + CORD_R}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
      </SchematicShell>
    );
  }

  // Front view — USB ports
  const usbCY = height * 0.5;
  const usbSpacing = 0.55 * IN;

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {[0, 1, 2].map((i) => (
        <Rect
          key={`usb-${i}`}
          x={width / 2 + (-1 + i) * usbSpacing - USB_W / 2}
          y={usbCY - USB_H / 2}
          width={USB_W}
          height={USB_H}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
      ))}
    </SchematicShell>
  );
}

DormSurgeProtectorSchematic.supportsSideViews = true;
